import {
  ApartSection,
  BelieveSection,
  OurSection,
  PointsSection,
  JoinSection,
} from "./sections";

const About = () => (
  <>
    <BelieveSection />
    <PointsSection />
    <OurSection />
    <ApartSection />
    <JoinSection />
  </>
);

export default About;
